import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { NavigationService } from './navigation.service';

export const adminMatchGuard: CanMatchFn = async () => {
  const nav = inject(NavigationService);
  await nav.whenReady();
  return nav.hasAdminAccess();
};
